var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgH2Off(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0427 17H12.25V7H11.0427V11.2995H6.45107V7H5.25V17H6.45107V12.3777H11.0427V17ZM18.75 16.2597V16.997H14.3867V16.3476L16.8477 13.6132C17.2122 13.1998 17.4629 12.8645 17.5996 12.6074C17.7396 12.3469 17.8096 12.0784 17.8096 11.8017C17.8096 11.4306 17.6973 11.1262 17.4727 10.8886C17.248 10.651 16.9486 10.5322 16.5742 10.5322C16.125 10.5322 15.7751 10.6607 15.5244 10.9179C15.277 11.1718 15.1533 11.5266 15.1533 11.9824H14.25C14.25 11.3281 14.46 10.7991 14.8799 10.3954C15.3031 9.9918 15.8678 9.78998 16.5742 9.78998C17.235 9.78998 17.7575 9.96413 18.1416 10.3124C18.5257 10.6575 18.7178 11.1181 18.7178 11.6943C18.7178 12.3941 18.2718 13.2275 17.3799 14.1943L15.4756 16.2597H18.75Z",
    fill: "white",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH2Off);
export default __webpack_public_path__ + "static/media/h2_off.f24ffe5aea81826179bfbc27259520e4.svg";
export { ForwardRef as ReactComponent };